import axios from 'axios';

const PortalStudentSkill = {
    namespaced: true,
    actions: {
        CreateStudentSkill({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalStudentSkill/CreateStudentSkill`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreateStudentSkillMidTerm({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalStudentSkill/CreateStudentSkillMidTerm`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetStudentForStudentSkill({ rootState }, { SectionId,SkillId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalStudentSkill/GetStudentForStudentSkill?SectionId=${SectionId}&SkillId=${SkillId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetStudentForStudentSkillMidTerm({ rootState }, { SectionId,SkillId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalStudentSkill/GetStudentForStudentSkillMidTerm?SectionId=${SectionId}&SkillId=${SkillId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },      

    }
}

export default PortalStudentSkill